import { __decorate, __metadata } from 'tslib';
import { Service } from '../../decorators/class/service.js';
import { ServiceNames } from '../../constants/service-name.js';
import { WidgetService } from '../widget/widget-service.js';

/**
 * 组件配置服务
 * @public
 */
let ConfigWidgetService = class ConfigWidgetService {
    constructor(widgetService) {
        this.widgetService = widgetService;
    }
    toggleWidgetService(serviceName, name, isOn) {
        if (isOn) {
            this.enableWidgetService(serviceName, name);
        }
        else {
            this.disableWidgetService(serviceName, name);
        }
    }
    disableWidgetService(serviceName, name) {
        if (serviceName === ServiceNames.FLOAT_WIDGET) {
            this.widgetService.exclude([name], 'float');
            this.widgetService.remove(name, 'float');
        }
        else if (serviceName === ServiceNames.EMBED_WIDGET) {
            this.widgetService.exclude([name], 'embed');
            this.widgetService.remove(name, 'embed');
        }
        else if (serviceName === ServiceNames.WRAPPED_WIDGET) {
            this.widgetService.exclude([name], 'wrap');
            this.widgetService.remove(name, 'wrap');
        }
    }
    enableWidgetService(_serviceName, _name) {
        // TODO: widgetService 缺乏接口去除exclude对象
    }
};
ConfigWidgetService = __decorate([
    Service({ overridable: true }),
    __metadata("design:paramtypes", [WidgetService])
], ConfigWidgetService);

export { ConfigWidgetService };
//# sourceMappingURL=config-widget-service.js.map
